import { Link } from "react-router-dom";
import { ellipseAddress } from "../../../utils/Helpers";
import moment from "moment";

function typeAlias(type) {
  switch (type) {
    case "CONTRACT":
      return "instantiate";
    case "CONTRACTCALL":
      return "call";
    case "CODEUPDATED":
      return "upgrade";
    case "CONTRACTTERMINATE":
      return "terminate";
    default:
      return type;
  }
}

const HistoryItem = (props) => {
  return (
    <tr>
      <td>
        <span className={`tag ${typeAlias(props.type)}`}>
          {typeAlias(props.type)}
        </span>
      </td>
      <td>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_EXPLORER_URL}/accounts/${props.from.id}`}
        >
          {ellipseAddress(props.from.id, 9)}
        </a>
      </td>
      <td>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_EXPLORER_URL}/accounts/${props.to.id}`}
        >
          {ellipseAddress(props.to.id, 9)}
        </a>
      </td>
      <td>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_EXPLORER_URL}/tx/${props.extrinsic.hash}`}
        >
          {props.extrinsic.success == true ? (
            <img src="/images/history2.svg" alt="" />
          ) : (
            <img src="/images/history3.svg" alt="" />
          )}
        </a>
      </td>
      <td>{moment(props.createdAt).format("MMM Do YYYY")}</td>
    </tr>
  );
};
export default HistoryItem;
